const IconPartnerCompany = ({ className }) => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 42 26' fill='none' className={className}>
            <path
                d='M17.1849 1.59617C16.0084 1.20931 14.7511 1 13.4448 1C6.84787 1 1.5 6.33832 1.5 12.9235C1.5 19.5086 6.84787 24.8469 13.4448 24.8469C20.0417 24.8469 25.3896 19.5086 25.3896 12.9235C25.3896 10.1636 24.4502 7.62271 22.8733 5.60204M23.7133 24.1685C24.9587 24.6079 26.2988 24.8469 27.6949 24.8469C34.2918 24.8469 39.6397 19.5086 39.6397 12.9235C39.6397 6.33832 34.2918 1 27.6949 1C21.098 1 15.7501 6.33832 15.7501 12.9235C15.7501 15.6834 16.6894 18.2242 18.2664 20.2449M35.212 16.2985L31.474 9.73894M35.144 16.3586L32.7335 17.7503M33.0916 13.9362L31.7096 14.7341M29.6485 9.84395C28.4135 9.50894 27.6777 8.23452 28.0051 6.99745C28.3325 5.76038 29.5991 5.02912 30.8341 5.36413C32.0691 5.69914 32.8049 6.97356 32.4775 8.21063C32.1501 9.4477 30.8836 10.179 29.6485 9.84395Z'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default IconPartnerCompany;
